// extracted by mini-css-extract-plugin
module.exports = {"select":"direct-access-links-create-page_select__30tE4","createDalLinksButtons":"direct-access-links-create-page_createDalLinksButtons__Hu2uE"};